import { usePaymentFlags } from '@/feature/devsettings/hooks/use-payment-flags-store';
import { useActiveWalletStore } from '@/hooks/use-active-wallet';
import { Product, useJurisdictionStore } from '@/hooks/use-jurisdiction';
import { SocialCurrency } from '@/hooks/use-social-currency';

/**
 * Custom hook that returns the availability of funding fantasy wallet using social wallet balance.
 * This funding flow is only eligible for Fantasy products.
 *
 * @returns {Object} Object containing fantasy wallet funding feature flags
 * @returns {boolean} isFantasyWalletFundingEnabled - True if fantasy wallet funding should be enabled
 */
export const useFantasyWalletFundingFlags = () => {
    const product = useJurisdictionStore(state => state.product);
    const socialWallet = useActiveWalletStore(state => state.wallets[Product.Sweeps]?.[SocialCurrency.CASH]);
    const { flags } = usePaymentFlags();
    const jurisdictionSettings = useJurisdictionStore(state => state.jurisdictionSettings);
    const settings = useJurisdictionStore(state => state.jurisdictionSettings?.globalSettings?.keyValuePairs);

    const isDebugMode = flags.isDebugMode.enabled;
    const isFantasyFundingProduct = product === Product.Pickem || product === Product.Arcade;
    const minimumDeposit = parseFloat(settings?.TransactionSettings?.minimum_deposit || '10');

    const isFantasyWalletFundingEnabledRaw = isDebugMode
        ? flags.enableFantasyFundWithSweeps.enabled
        : jurisdictionSettings?.productConfig?.settings?.enable_fantasy_fund_with_ssbk ?? false;

    if (!isFantasyFundingProduct) {
        return {
            isFantasyWalletFundingEnabled: false,
        };
    }

    const socialRedeemableBalance = parseFloat(socialWallet?.real_amount || '0');

    return {
        isFantasyWalletFundingEnabled: socialRedeemableBalance >= minimumDeposit && isFantasyWalletFundingEnabledRaw,
    };
};
